// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Zp-z","slideIn":"_p-z"};